import { APP_NAME, metafieldFields } from "../fields";
import { collectionFragment, metaObjectImageFragment, metaObjectProductFragment } from "../fragments";

export const metaObjectFragment = {
  operation: "Metaobject",
  fields: ["id", { fields: ["key", "value"] }],
  fragment: true,
};

const hiddenName: Record<string, string> = {
  tune: '(namespace: "custom", key: "hidden")',
  yeseyesee: '(namespace: "custom", key: "hidden")',
  thisisneverthat: '(namespace: "operation", key: "hidden")',
  khakis: '(namespace: "operation", key: "hidden")',
  jknd: '(namespace: "operation", key: "hidden")',
};

export const hiddenMetafield = {
  operation: {
    name: `metafield${hiddenName[APP_NAME]}`,
    alias: "hidden",
  },
  fields: metafieldFields,
  variables: {},
};

export const employeeOnlyMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "employee_only")',
    alias: "employeeOnly",
  },
  fields: metafieldFields,
  variables: {},
};

export const launchMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "launch")',
    alias: "launch",
  },
  fields: [...metafieldFields, { reference: [metaObjectImageFragment] }],
  variables: {},
};

const quantityName: Record<string, string> = {
  tune: '(namespace: "custom", key: "quantity_limit")',
  yeseyesee: '(namespace: "operation", key: "quantity_limit")',
  thisisneverthat: '(namespace: "operation", key: "quantity_limit")',
  khakis: '(namespace: "operation", key: "quantity_limit")',
  jknd: '(namespace: "operation", key: "quantity_limit")',
};

export const quantityLimitMetafield = {
  operation: {
    name: `metafield${quantityName[APP_NAME]}`,
    alias: "quantityLimit",
  },
  fields: metafieldFields,
  variables: {},
};

const noticeName: Record<string, string> = {
  tune: '(namespace: "notice", key: "content")',
  yeseyesee: '(namespace: "info", key: "notice")',
  thisisneverthat: '(namespace: "notice", key: "content")',
  khakis: '(namespace: "notice", key: "content")',
  jknd: '(namespace: "notice", key: "content")',
};

export const noticeMetafield = {
  operation: {
    name: `metafield${noticeName[APP_NAME]}`,
    alias: "notice",
  },
  fields: metafieldFields,
  variables: {},
};

const warningName: Record<string, string> = {
  khakis: '(namespace: "warning", key: "content")',
};

export const warningMetafield = {
  operation: {
    name: `metafield${warningName[APP_NAME]}`,
    alias: "warning",
  },
  fields: metafieldFields,
  variables: {},
};

export const informationMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "information")',
    alias: "information",
  },
  fields: metafieldFields,
  variables: {},
};

const additionalDescriptionName: Record<string, string> = {
  tune: '(namespace: "additional", key: "description")',
  yeseyesee: '(namespace: "info", key: "additional_description")',
  thisisneverthat: '(namespace: "info", key: "additional_description")',
  khakis: '(namespace: "info", key: "additional_description")',
  jknd: '(namespace: "info", key: "additional_description")',
};

export const additionalDescriptionMetafield = {
  operation: {
    name: `metafield${additionalDescriptionName[APP_NAME]}`,
    alias: "additionalDescription",
  },
  fields: metafieldFields,
  variables: {},
};

const sizeChartName: Record<string, string> = {
  tune: '(namespace: "size", key: "chart")',
  yeseyesee: '(namespace: "info", key: "size_chart")',
  thisisneverthat: '(namespace: "info", key: "size_chart")',
  khakis: '(namespace: "size", key: "chart")',
  jknd: '(namespace: "info", key: "size_chart")',
};

export const sizeChartMetafield = {
  operation: {
    name: `metafield${sizeChartName[APP_NAME]}`,
    alias: "sizeChart",
  },
  fields: metafieldFields,
  variables: {},
};

export const dropDateMetafield = {
  operation: {
    name: 'metafield(namespace: "drops", key: "date")',
    alias: "dropDate",
  },
  fields: metafieldFields,
  variables: {},
};

export const tagMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "tag")',
    alias: "tag",
  },
  fields: metafieldFields,
  variables: {},
};

export const categoryMetafield = {
  operation: {
    name: 'metafield(namespace: "category", key: "sub")',
    alias: "category",
  },
  fields: metafieldFields,
  variables: {},
};

export const productVariantMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "restock_notification")',
    alias: "restock",
  },
  fields: metafieldFields,
  variables: {},
};

export const seungsuStockMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "seongsu_stock")',
    alias: "seoungsu_stock",
  },
  fields: metafieldFields,
  variables: {},
};

export const preorderMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "preorder")',
    alias: "preorder",
  },
  fields: [...metafieldFields, { reference: [metaObjectFragment] }],
  variables: {},
};

export const quantityLimitProductMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "quantity_limit_product")',
    alias: "quantityLimitProduct",
  },
  fields: metafieldFields,
  variables: {},
};

export const sizeFitMetafield = {
  operation: {
    name: 'metafield(namespace: "size-fit", key: "values")',
    alias: "size_fit",
  },
  fields: metafieldFields,
  variables: {},
};

export const availableCountriesMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "available_countries")',
    alias: "available_countries",
  },
  fields: metafieldFields,
  variables: {},
};

export const modelMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "size")',
    alias: "model",
  },
  fields: metafieldFields,
  variables: {},
};

export const maleModelMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "info")',
    alias: "maleModel",
  },
  fields: metafieldFields,
  variables: {},
};

export const femaleModelMetafield = {
  operation: {
    name: 'metafield(namespace: "model", key: "info2")',
    alias: "femaleModel",
  },
  fields: metafieldFields,
  variables: {},
};

export const relatedCollectionMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "related_collection")',
    alias: "related_collection",
  },
  fields: [
    {
      operation: "references(first: 10)",
      fields: [{ edges: [{ node: [collectionFragment] }] }],
      variables: {},
    },
  ],
  variables: {},
};

export const releaseDateMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "release_date")',
    alias: "release_date",
  },
  fields: metafieldFields,
  variables: {},
};

export const recommendedStyleMetafield = {
  operation: {
    name: 'metafield(namespace: "info", key: "recommended_style")',
    alias: "recommended_style",
  },
  fields: [...metafieldFields, { reference: [metaObjectImageFragment, metaObjectProductFragment] }],
  variables: {},
};

export const membershipMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "accessible_memberships")',
    alias: "accessible_memberships",
  },
  fields: metafieldFields,
  variables: {},
};

export const brandVariantIdMetafield = {
  operation: {
    name: 'metafield(namespace: "familysale", key: "brand_variant_id")',
    alias: "brandVariantId",
  },
  fields: metafieldFields,
  variables: {},
};

export const saleMetafield = {
  operation: {
    name: 'metafield(namespace: "familysale", key: "sale")',
    alias: "sale",
  },
  fields: metafieldFields,
  variables: {},
};
